import React, { useState } from "react";
import { Instagram, Facebook, WhatsApp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const [clickCount, setClickCount] = useState(0);

  return (
    <footer className="bg-[#fff0f0] dark:bg-gray-900 mt-4 pt-6 text-center text-gray-800 dark:text-gray-200 transition-colors duration-300">
      {/* Logo & Title */}
      <div className="flex flex-col items-center gap-2">
        <img src="/android-chrome-512x512.png" alt="Fluteon Logo" className="w-14 h-16 object-contain rounded-xl" />
        <h2 className="text-xl font-semibold font-serif">Fluteon</h2>
      </div>

      {/* Nav Links */}
      <div className="mt-3 flex flex-col gap-3 items-center">
        <button onClick={() => navigate("/")} className="bg-gray-200 dark:bg-gray-700 dark:text-gray-200 px-6 py-2 rounded-full w-52 font-medium hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors">Home</button>
        <button onClick={() => navigate("/about-us")} className="bg-gray-200 dark:bg-gray-700 dark:text-gray-200 px-6 py-2 rounded-full w-52 font-medium hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors">About-Us</button>
        <button onClick={() => navigate("/contact-us")} className="bg-gray-200 dark:bg-gray-700 dark:text-gray-200 px-6 py-2 rounded-full w-52 font-medium hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors">Contact-Us</button>
      </div>

      {/* Blob-Shaped Social Section */}
      <div className="relative ">
        <svg viewBox="0 0 500 150" preserveAspectRatio="none" className="w-full h-24 -mb-1">
          <path
            d="M0,100 C150,200 350,0 500,100 L500,150 L0,150 Z"
            fill="#f94f4f"
          />
        </svg>

        <div className="bg-[#f94f4f] text-white pt-4 pb-4 px-6">
          <h4 className="text-sm font-semibold mb-4 tracking-wider uppercase">
            social media buddies!
          </h4>
          <div className="flex justify-center gap-6 text-white mb-4">
            <a href="https://www.instagram.com/fluteon1?igsh=NDFhZXBvamdzcnFr" target="_blank" rel="noreferrer"><Instagram /></a>
            <a href="https://www.facebook.com/share/1GGkBWgRpV/" target="_blank" rel="noreferrer"><Facebook /></a>
            <a href="https://wa.me/98925 50941" target="_blank" rel="noreferrer"><WhatsApp /></a>
          </div>
          <p 
            className="text-xs cursor-pointer select-none"
            onClick={() => setClickCount(prev => prev + 1)}
          >
            © 2026 All rights reserved
          </p>
          <div className="flex justify-center gap-4 text-xs mt-1">
            <a onClick={() => navigate("/terms-condition")} className="underline cursor-pointer">Terms</a>
            <a onClick={() => navigate("/privaciy-policy")} className="underline cursor-pointer">Privacy</a>
          </div>
          <p className={clickCount >= 5 ? "text-[12px] mt-2 transition-all duration-500 opacity-100" : "dev-credit"}>
            Designed & Developed by <a href="https://aryesh.in/" target="_blank" rel="noopener noreferrer" className="underline hover:opacity-100 transition-opacity">Aryesh Shivmare</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
